
import { defineComponent } from 'vue'
import { DeviceEnum } from '../../enums'

export default defineComponent({
  name: 'LoginInput',
  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: String,
    name: String,
    icon: String,
  },
  data() {
    return {
      DeviceEnum,
    }
  },
  methods: {
    onInputChange() {
      const inputEl: HTMLInputElement = this.$refs.input as HTMLInputElement
      this.$emit('input', inputEl.value)
    },
  },
})
